// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
import queryString from "query-string";
const BASE_URI = "/business";

export default {
  /**
   * Gets all businesses from backend server
   * @param searchText
   */
  quicksearch(searchText: string) {
    const filter = {
      searchText: searchText,
      pageSize: 20,
      pageNumber: 1,
      includeLinkedAccountNameSearch: true,
      includeLinkedContactNameSearch: true,
    };
    const url = BASE_URI + "/?" + queryString.stringify(filter);
    return backend.get(url);
  },

  /**
   * Gets the business reference data
   * @returns {object} - The business reference data
   */
  getReferenceData() {
    return backend.get("/businessreferencedata");
  },
};
